import { CloseIcon } from "vega-icons";

import {
  ThemedIconButton,
  type ThemedIconButtonProps,
} from "../ThemedIconButton";

type Props = Pick<ThemedIconButtonProps, "disabled" | "onClick"> & {
  noBg?: boolean;
};

export const CloseButton = ({ disabled, noBg = false, onClick }: Props) => (
  <ThemedIconButton
    ariaLabel="Close"
    className="rounded-full bg-background/component/[0.1] border-none"
    dataTestId="close-button"
    disabled={disabled}
    icon={<CloseIcon />}
    onClick={onClick}
    size="small"
    variant={noBg ? "noBackground" : "background"}
  />
);
